import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-circle-outline",
  "use": "icon-common-circle-outline-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" fill=\"none\" id=\"icon-common-circle-outline\">\n  <path d=\"M12.251 7.13684C12.251 4.2384 9.89942 1.88684 7.00098 1.88684C4.10254 1.88684 1.75098 4.2384 1.75098 7.13684C1.75098 10.0353 4.10254 12.3868 7.00098 12.3868C9.89942 12.3868 12.251 10.0353 12.251 7.13684Z\" fill=\"white\" stroke=\"#1D1D1D\" stroke-width=\"1.00189\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol